module.exports = __webpack_public_path__ + "static/media/grid4.cfd60f4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/grid4.jpg
// module id = 882
// module chunks = 0